export function navigateTopLevel(url: string): void {
  const isInIframe = window.self !== window.top && window.top !== null;

  if (isInIframe && window.top) {
    window.top.location.href = url;
  } else {
    window.location.href = url;
  }
}
